var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.164,44.522v-1.473c0-1.104-0.896-2-2-2H33.41c-1.104,0-2,0.896-2,2v10.18c0,9.03,7.347,16.377,16.377,16.377 c5.748,0,10.805-2.984,13.728-7.477c0.217,0.017,0.435,0.041,0.649,0.041c4.931,0,8.941-4.011,8.941-8.941 C71.105,48.988,68.134,45.434,64.164,44.522z M47.787,65.606c-6.825,0-12.377-5.553-12.377-12.377v-8.18h24.754v1.239v6.941 c0,0.469-0.032,0.932-0.083,1.391c-0.018,0.163-0.049,0.322-0.074,0.482c-0.045,0.296-0.096,0.591-0.163,0.882 c-0.04,0.176-0.087,0.349-0.135,0.523c-0.079,0.287-0.169,0.571-0.269,0.852c-0.053,0.149-0.105,0.299-0.163,0.446 c-0.143,0.357-0.304,0.708-0.481,1.055C56.742,62.858,52.583,65.606,47.787,65.606z M63.451,58.001 c0.005-0.017,0.008-0.034,0.013-0.051c0.123-0.408,0.228-0.822,0.319-1.238c0.04-0.185,0.071-0.372,0.105-0.559 c0.057-0.314,0.106-0.628,0.145-0.945c0.021-0.169,0.042-0.338,0.057-0.509c0.044-0.489,0.074-0.978,0.074-1.47v-4.518 c1.731,0.769,2.941,2.505,2.941,4.518C67.105,55.51,65.554,57.433,63.451,58.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.787,39.469c1.104,0,2-0.896,2-2c0-1.686,1.372-3.057,3.058-3.057h7.005c3.655,0,6.629-2.974,6.629-6.628 s-2.974-6.628-6.629-6.628c-1.104,0-2,0.896-2,2s0.896,2,2,2c1.449,0,2.629,1.179,2.629,2.628s-1.18,2.628-2.63,2.628h-7.004 c-3.892,0-7.058,3.166-7.058,7.057C45.787,38.574,46.683,39.469,47.787,39.469z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.c28509e7ec5a4a16b54a9aa09c7ae255.svg";
export { ForwardRef as ReactComponent };